

const getLanguageFromLocale = (locale: string) => {
	switch (locale) {
		case "nl_NL":
		case "nl-NL": {
			return 'nl-NL';
		}
		case "en_US":
		case "en-US": {
			return 'en-US';
		}
		default: {
			return 'fr-FR';
		}
	}
};

export default getLanguageFromLocale;
